import App from '@/models/App'

export default class OrderingOrdererEstimateApproval extends App {
    static get entity() {
        return 'OrderingOrdererEstimateApprovals'
    }

    static fields() {
        return {
            id: this.attr(''),
            orderingEstimateId: this.attr(''),
            orderingAccountId: this.attr(''),
            userId: this.attr(''),
            user: this.attr(''),
            sort: this.attr(0),
            approvedAt: this.attr(''),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
        }
    }

    static apiConfig = {
        actions: {
            approvalRequest(orderingShipId, orderingOrderId, orderingEstimateId, orderingEstimateApprovalId, sendAll = false) {
                return this.patch(
                    `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/estimates/${orderingEstimateId}/approvals/${orderingEstimateApprovalId}/request`,
                    App.patch({
                        sendAll: sendAll,
                    }),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            approvalDo(orderingShipId, orderingOrderId, orderingEstimateId, orderingEstimateApprovalId) {
                return this.patch(
                    `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/estimates/${orderingEstimateId}/approvals/${orderingEstimateApprovalId}/do`,
                    App.patch({}),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            approvalReturn(orderingShipId, orderingOrderId, orderingEstimateId, orderingEstimateApprovalId, message = '') {
                return this.patch(
                    `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/estimates/${orderingEstimateId}/approvals/${orderingEstimateApprovalId}/return`,
                    App.patch({
                        message: message,
                    }),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            }
        },
    }
}
